// extracted by mini-css-extract-plugin
module.exports =  {"search":"search--VeoRj"};